import './index.css';
import './lib/dynamicImportErrorListener';
import './lib/sentry';
import './lib/swiper';
import './lib/swUpdate';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
